import planundertarget from "./planundertarget.svg";

export default function PlanUnderTargetIcon() {
  return (
    <img src={planundertarget} />
  );
}